import { render, staticRenderFns } from "./consulta_campo_paragrafo.vue?vue&type=template&id=1166f9fb&scoped=true&"
import script from "./consulta_campo_paragrafo.vue?vue&type=script&lang=js&"
export * from "./consulta_campo_paragrafo.vue?vue&type=script&lang=js&"
import style0 from "./consulta_campo_paragrafo.vue?vue&type=style&index=0&id=1166f9fb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1166f9fb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VTextarea})
